import { render } from "./IDropdown.vue?vue&type=template&id=b67ea8ba"
import script from "./IDropdown.vue?vue&type=script&lang=js"
export * from "./IDropdown.vue?vue&type=script&lang=js"

import "./IDropdown.vue?vue&type=style&index=0&id=b67ea8ba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__